import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useEffect, useState } from 'react';
import { Carousel } from 'antd';
const ContentProject = (props) => {
    const [project, setProject] = useState([]);
    const contentStyle = {
        margin: 0,
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
    };
    useEffect(() => {
        console.log('ContentProject props:', props.info);
        setProject(props.info);
    }, [props.info]);

    return (
        <div className="detail-gallery">
             <div className="themesflat-spacer clearfix" data-desktop={21} data-mobile={21} data-smobile={21} />
            <div
                className="themesflat-gallery style-2 has-arrows arrow-center arrow-circle offset-v-82 has-thumb w185 clearfix"
                data-gap={0} data-column={1} data-column2={1} data-column3={1} data-auto="false" 
             > 
                {/* <OwlCarousel items={1}  loop nav margin={8}>
                    {props.info?.photos?.length > 0 && props.info.photos.map((item, idx) => (
                        <div className="gallery-item" key={idx}>
                            <div className="inner">
                                <div className="thumb">
                                    <img src={item.path} alt="imagealt" />
                                </div>
                            </div>
                        </div>
                    ))} */}
                {/* </OwlCarousel> */}

                <Carousel arrows infinite={true} autoplay={true } autoplaySpeed={3000} >
            

                    {props.info?.photos?.length > 0 && props.info.photos.map((item, idx) => {
                        // Force HTTPS for image URLs to avoid mixed content
                        let imgSrc = item.path;
                        // If image is from 3.73.248.105:3132, proxy it through Express for HTTPS
                        if (imgSrc && imgSrc.startsWith('http://3.73.248.105:3132/')) {
                            imgSrc = '/api/image' + imgSrc.replace('http://3.73.248.105:3132', '');
                        }
                        return (
                            <div key={idx}>
                                <img src={imgSrc} style={{  height: "50vh",
                                            width: "100%",
                                            objectFit: "cover"}} alt="imagealt" />
                            </div>
                        );
                    })}

                </Carousel>
            </div>
            <div className="themesflat-spacer clearfix" data-desktop={40} data-mobile={40} data-smobile={40} />
            <div className="flat-content-wrap style-3 clearfix">
                <h5 className="title">AÇIKLAMA</h5>
                <div className="sep has-width w60 accent-bg margin-top-18 clearfix" />
                <p className="margin-top-28">
                    {project.description}
                </p>
               
                  
                
            </div> 
        </div>
    );
}

export default ContentProject;
